import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert } from '@c2fo/liquidity';
import { useOfferModalClearSchedules, UseOfferModalClearSchedulesOptions } from '../useOfferModalClearSchedules';
import { scheduleTimeZone } from '../utils';

export const ScheduleEndDateWarning = ({ takerMarkets, startDate, endDate }: UseOfferModalClearSchedulesOptions) => {
  const { t } = useTranslation();
  const finalClearsByTakerMarket = useOfferModalClearSchedules({ takerMarkets, startDate, endDate });
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    if (!endDate) {
      setShowWarning(false);
      return;
    }

    // set divisionDoesNotHaveClearBeforeEndDate if at least one division does not have a clear before the end date
    const divisionDoesNotHaveClearBeforeEndDate = finalClearsByTakerMarket.some((clears) => {
      // returns false if there is a clear before end date, return true if there is no clear before end date
      return !clears.clearSchedules.some((clear) => {
        const clearTimeInScheduleTimeZone = clear.clearTimeInScheduleTimeZone;

        const endDateInScheduleTimeZone = new Date(
          new Date(`${endDate}T23:59:59`).toLocaleString('en-US', { timeZone: scheduleTimeZone })
        );

        // Check if clear date is on or before end date
        return clearTimeInScheduleTimeZone <= endDateInScheduleTimeZone;
      });
    });

    setShowWarning(divisionDoesNotHaveClearBeforeEndDate);
  }, [finalClearsByTakerMarket, endDate]);

  if (showWarning) {
    return (
      <Alert
        type="warning"
        variant="outlined"
        description={t(`scheduling.noProcessingBeforeEndDate.division`, { count: takerMarkets.length })}
        full
      />
    );
  }

  return null;
};
